/**
 * Holds the routed area open while a route chunk is still loading.
 *
 * The boundary used to render `null`, which let the header and footer collapse
 * against each other — the page looked like it had lost its content rather than
 * like it was loading. Every page ships a skeleton of its own, but those live
 * inside the chunk being fetched, so the fallback has to be something the entry
 * bundle already carries.
 *
 * The height is deliberately generous: it is cheaper to reserve a little too
 * much and have the page settle upwards than to reserve too little and push the
 * footer down after the chunk lands, which is a layout shift the browser counts.
 */
export const RouteFallback = () => (
  <div className="min-h-[70vh] w-full" aria-busy="true" aria-live="polite" />
);
